<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
    <template
       
         slot="dateStartRangeSearch"
      >
            <div style="display: flex;">
              <el-date-picker
              style="width:42%;"
              v-model="query.timeStart"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.timeEnd"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            </div>
      </template>
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.bankcutpayment_add"
          @click="openCutPaymentAddDialog"
          >生成划扣文件
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-download"
          v-if="permission.bankcutpayment_download"
          @click="rowDownload(scope.row)"
          >划扣文件
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-upload2"
          v-if="permission.bankcutpayment_upload"
          @click="openCutPaymentOffsetDialog(scope.row)"
          >返盘销账
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="生成划扣文件"
      :visible.sync="cutPaymentAddShowDialogFlag"
      @close="quitCutPaymentAddDialog"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          v-loading="cutFormLoading"
          :element-loading-text="cutFormLoadingText"
          ref="cutPaymentAddFormRef"
          v-model="cutPaymentAddForm"
          :option="cutPaymentAddOption"
          @submit="cutPaymentAddSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCutPaymentAddDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="上传返盘文件销账"
      :visible.sync="cutPaymentOffsetShowDialogFlag"
      @close="cutPaymentOffsetDialog"
      append-to-body
    >
      <div class="el-property-dialog-div">
        <el-upload
          class="c-upload"
          ref="upload"
          action=""
          :headers="myHeaders"
          :data="myData"
          :limit="1"
          accept=".xls, .xlsx"
          :before-remove="beforeRemove"
          :on-exceed="handleExceed"
          :on-change="onChange"
          :http-request="uploadImg"
          :on-success="onSuccess"
          :file-list="fileList"
          :before-upload="beforeUpload"
          :auto-upload="false"
        >
          <el-button 　　slot="trigger" 　　size="small" 　　type="primary" 　
            >选取返盘文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            请根据对应下载文件上传返盘文件.xls,销账只能执行一次，且文件不超过一个。
          </div>
        </el-upload>
        <avue-form
          ref="cutPaymentOffsetFormRef"
          v-model="cutPaymentOffsetForm"
          :option="cutPaymentOffsetOption"
          @submit="cutPaymentOffsetPreSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitCutPaymentOffsetDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
  import {getToken} from '@/util/auth';
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getAmountAndCutNum,
  checkBill,
  submitUploadBill,
} from '@/api/v4ward/bankcut/bankcutpayment';
import { mapGetters } from 'vuex';
import axios from 'axios';
import cutPaymentAddOption from './bankcutpayment-add-option';
import cutPaymentOffsetOption from './bankcutpayment-offset-option';
export default {
  data() {
    return {
      fileList: [],
      isCutPaymentAddDialogFirstOpen: true,
      cutPaymentAddShowDialogFlag: false,
      cutPaymentAddForm: {},
      cutPaymentAddOption: cutPaymentAddOption,
      isCutPaymentOffsetDialogFirstOpen: true,
      cutPaymentOffsetShowDialogFlag: false,
      cutPaymentOffsetForm: {},
      cutPaymentOffsetOption: cutPaymentOffsetOption,
      form: {},
      query: {
        timeStart:'',
        timeEnd:'',
      },
      loading: true,
      cutFormLoading: false,
      cutFormLoadingText: '',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      fileListNum: true,
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 50,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        selection: true,
        labelWidth: 150,
        searchMenuSpan: 6,
        columnBtn: false,
        refreshBtn: false,
        column: [
          {
            label: '扣款银行',
            prop: 'cutBank',
            width: 120,
            searchSpan: 5,
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=bill_cutBank',
            props: { label: 'dictValue', value: 'dictKey' },
            search: true,
          },
          {
            label: '扣款时间',
            prop: 'cutTime',
            width: 120,
          },
          {
            label: '扣款周期',
            prop: 'billcycleNo',
          },
          {
            label: '扣款状态',
            prop: 'cutStatus',
            width: 100,
            searchSpan: 5,
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=deductions_status',
            props: { label: 'dictValue', value: 'dictKey' },
            search: true,
          },
          {
            label: '收费类型',
            prop: 'feeSort',
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=fee_sort',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '扣款笔数',
            prop: 'cutNum',
          },
          {
            label: '扣款总额',
            prop: 'cutAmount',
          },
          {
            label: '成功笔数',
            prop: 'successNum',
          },
          {
            label: '成功总额',
            prop: 'successAmount',
          },
          {
            label: '失败笔数',
            prop: 'faultNum',
          },
          {
            label: '失败总额',
            prop: 'faultAmount',
          },
          {
            label: '执行人',
            prop: 'cutEmpName',
            hide: true,
          },
          {
            label: '扣款文件',
            prop: 'sentAddress',
            hide: true,
          },
          {
            label: '扣款备注',
            prop: 'cutRemark',
            hide: true,
            type: 'textarea',
            minRows: 5,
            maxlength: 100,
            span: 24,
          },
          {
            label: '返盘更新人',
            prop: 'backEmpName',
            hide: true,
          },
          {
            label: '返盘更新时间',
            prop: 'backTime',
            width: 120,
          },
          {
            label: '返盘文件',
            prop: 'backAddress',
            hide: true,
          },
          {
            label: '返盘更新备注',
            prop: 'backRemark',
            hide: true,
            type: 'textarea',
            minRows: 5,
            maxlength: 100,
            span: 24,
          },
          {
            label: '返盘日期',
            prop: 'dateStartRange',
           
            search: true,
            searchslot:true,

            searchSpan: 8,
            // type: 'datetimerange',
            // format: 'yyyy-MM-dd HH:mm:ss',
            // valueFormat: 'yyyy-MM-dd HH:mm:ss',
            // editDisplay: false,
            // addDisplay: false,
            // viewDisplay: false,
            // span: 16,
            hide: true,
          },
        ],
      },
      data: [],
    };
  },
  mounted() {
    this.form.status = 0;
    // this.obj.switch = 0;
    // this.obj.phone='17547400800';
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.bankcutpayment_add, false),
        viewBtn: this.vaildData(this.permission.bankcutpayment_view, false),
        delBtn: this.vaildData(this.permission.bankcutpayment_delete, false),
        editBtn: this.vaildData(this.permission.bankcutpayment_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
        .then(() => {
          this.fileList = [];
          this.fileListNum = true;
          return Promise.resolve();
        })
        .catch(() => {
          return Promise.reject();
        });
    },
    onChange(file, fileList) {
      this.fileListNum = false;
      var testmsg = file.name;
      const extension = testmsg === this.cutPaymentOffsetForm.sentAddress;
      if (!extension) {
        this.$confirm('与原生成文件名称差异过大，请仔细检查文件', {
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose:(action, instance, done)=>{
            done();
          }
        })
          .then(() => {
            this.fileList = [];
            this.fileListNum = true;
          })
          .catch(() => {
            this.fileList = [];
            this.fileListNum = true;
          });
      }
    },
    rowDownload(row) {
      window.open(`/api/v4ward/bankCut/payment/download?Blade-Auth=${getToken()}&sentAddress=` + row.sentAddress);
    },
    rowDownloadTest(row) {
      let fileName = row.sentAddress;
      axios
        .get('/api/v4ward/bankCut/payment/download?sentAddress=' + fileName, {
          responseType: 'blob',
          timeout: 60000,
        })
        .then((r) => {
          const content = r.data;
          const blob = new Blob([content], { type: 'application/xsl' });
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.href = URL.createObjectURL(blob);
          elink.click();
          window.URL.revokeObjectURL(blob);
          this.$message.success('操作成功');
        });
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    openCutPaymentAddDialog() {
      this.cutPaymentAddShowDialogFlag = true;
    },
    quitCutPaymentAddDialog() {
      this.cutPaymentAddShowDialogFlag = false;
      this.$refs.cutPaymentAddFormRef.resetForm();
    },
    cutPaymentAddSubmit(form, done) {
      if (form.cutNum <= 0) {
        this.$message.warning('没有划扣账单，不生成划扣文件！');
        done();
        return;
      }

      add(form).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.cutPaymentAddShowDialogFlag = false;
          this.$refs.cutPaymentAddFormRef.resetForm();
          done();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    cutPaymentOffsetDialog() {
      this.quitCutPaymentOffsetDialog();
    },
    openCutPaymentOffsetDialog(row) {
      if (row.cutStatus === 3) {
        this.$message.warning('已经在返盘中');
        return;
      } else if (row.cutStatus === 2) {
        this.$message.warning('已执行销账，请不要重复销账');
        return;
        // this.quitCutPaymentOffsetDialog();
      }
      if (row.propertyFlag === 1) {
        row.feeSort = 1;
      }
      if (row.otherFlag === 1) {
        row.feeSort = 2;
      }
      if (row.replaceFlag === 1) {
        row.feeSort = 3;
      }
      this.cutPaymentOffsetForm = row;

      // getDetail({ id: row.id }).then(({ data }) => {
      //   this.cutPaymentOffsetForm = data;
      // });
      this.cutPaymentOffsetShowDialogFlag = true;
    },
    quitCutPaymentOffsetDialog() {
      this.$refs.upload.clearFiles();
      this.cutPaymentOffsetShowDialogFlag = false;
      this.$refs.cutPaymentOffsetFormRef.resetForm();
      this.fileList = [];
      this.fileListNum = true;
    },
    uploadImg(file, done) {
      this.fileList[0] = file.file;
      const formData = new FormData();
      formData.append('file', this.fileList[0]);
      // 需要用户二次确认信息后再真正执行返盘操作
      checkBill(formData)
        .then(({ data }) => {
          this.cutFormLoading = false;
          this.$confirm(
            `成功笔数：${data.successCount}(${data.successAmount}元)，失败笔数：${data.failCount}(${data.failAmount}元)，是否继续？`,
            {
              title: '划扣信息',
              confirmButtonText: '继续',
              cancelButtonText: '取消',
              closeOnClickModal: false, // 点击遮罩不要关闭该弹框，如果用户连点“销账”按钮，这会将此弹框打开又关闭
            }
          )
            .then(() => {
              this.cutPaymentOffsetSubmit();
            })
            .catch(() => {});
        })
        .catch(() => {
          this.cutFormLoading = false;
        });
    },
    cutPaymentOffsetSubmit() {
      const formData = new FormData();
      formData.append('id', this.cutPaymentOffsetForm.id);
      formData.append('backRemark', this.cutPaymentOffsetForm.backRemark);
      formData.append('file', this.fileList[0]);
      submitUploadBill(formData).then(
        (r) => {
          this.$message.success(r.msg);
          this.onLoad();
          this.cutPaymentOffsetShowDialogFlag = false;
          this.$refs.cutPaymentOffsetFormRef.resetForm();
          this.fileListNum = true;
          this.fileList = [];
        },
        (error) => {
          console.log(error);
        }
      );
    },
    cutPaymentOffsetPreSubmit(done, loading) {
      loading();
      if (this.fileListNum) {
        this.$message.error('请选择文件');
        return;
      }
      this.cutFormLoadingText = '正在校验文件...';
      this.cutFormLoading = true;
      this.$refs.upload.submit();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
    
      this.query.cutBank = '';
      this.query.cutStatus ="";
      this.query.timeStart =""
      this.query.timeEnd =""
      this.onLoad();
    },
    searchChange(params, done) {
     
      this.query.cutBank = params.cutBank
      this.query.cutStatus = params.cutStatus
      console.log(this.query);
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
     let obj =Object.assign({},this.query);
     if(obj.timeStart==''){
       delete obj.timeStart
     }
     if(obj.timeEnd==''){
       delete obj.timeEnd
     }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, obj)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
  watch: {
    'cutPaymentAddForm.billcycleNo'() {
      if (this.cutPaymentAddForm.billcycleNo) {
        if (this.cutPaymentAddForm.bankId) {
          if (this.cutPaymentAddForm.feeSort) {
            this.cutFormLoadingText = '正在查询账单...';
            this.cutFormLoading = true;
            getAmountAndCutNum(
              Object.assign({
                bankId: this.cutPaymentAddForm.bankId,
                billcycleNo: this.cutPaymentAddForm.billcycleNo,
                feeSort: this.cutPaymentAddForm.feeSort,
              })
            ).then(({ data }) => {
              this.cutPaymentAddForm.cutNum = data.cutNum;
              this.cutPaymentAddForm.cutAmount = data.cutAmount;
              this.cutFormLoading = false;
            });
          } else {
            this.$message.error('请先选择费用种类和扣款银行');
            this.cutPaymentAddForm.billcycleNo = '请先选择费用种类和扣款银行';
          }
        } else {
          this.$message.error('请先选择费用种类和扣款银行');
          this.cutPaymentAddForm.billcycleNo = '请先选择费用种类和扣款银行';
        }
      }
    },
    'cutPaymentAddForm.feeSort'() {
        if(this.cutPaymentAddForm.billcycleNo){
          this.cutPaymentAddForm.billcycleNo = '';
        }
    },
    'cutPaymentAddForm.bankId'() {
      if(this.cutPaymentAddForm.billcycleNo){
        this.cutPaymentAddForm.billcycleNo = '';
      }
    },
  },
};
</script>

<style scoped>
.el-property-dialog-div {
  height: inherit;
  /* overflow: auto; */
}
.el-dialog__body {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>
